import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCashDeskSettingsBeeperConfigsThunk, getCashDeskSettingsCartSettingsThunk, getCashDeskSettingsChangeSettingsThunk, getCashDeskSettingsPrintSettingsThunk, getCashDeskSettingsWaiterSettingsThunk } from '../../../redux/thunk/cashDeskSettings'
import CashDeskWaiterSettings from './waiter'
import { CartSettingForCashDeskWrap } from './index.styled'
import CashDeskProductQuantitySettings from './productQuantity'
import CashDeskBeeperSettings from './beeper'
import CashDeskChangeSettings from './change'
import CashDeskPrintSettings from './print'
import { CASH_DESK_MODULE } from '../constants'

const CartSettingForCashDesk = React.memo(() => {
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getCashDeskSettingsCartSettingsThunk(CASH_DESK_MODULE))
		dispatch(getCashDeskSettingsChangeSettingsThunk(CASH_DESK_MODULE))
		dispatch(getCashDeskSettingsWaiterSettingsThunk(CASH_DESK_MODULE))
		dispatch(getCashDeskSettingsPrintSettingsThunk(CASH_DESK_MODULE))
		dispatch(getCashDeskSettingsBeeperConfigsThunk(CASH_DESK_MODULE))
	}, [dispatch])

	return (
		<CartSettingForCashDeskWrap>
			<CashDeskWaiterSettings />
			<CashDeskBeeperSettings />
			<CashDeskProductQuantitySettings />
			<CashDeskChangeSettings />
			<CashDeskPrintSettings />
		</CartSettingForCashDeskWrap>
)
})

CartSettingForCashDesk.displayName = 'CartSettingForCashDesk'
export default CartSettingForCashDesk
